import { ImageCarousel } from "../components/Carousel/ImageCarousel"
import { TextCarousel } from "../components/Carousel/TextCarousel"

export const FirstSection = () => {
  return (
    <div className="container-fluid">
      <TextCarousel />
      <ImageCarousel />
    </div>
  )
}
